"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const status_and_notifications_1 = require("../../../../hsbc_img/status_and_notifications");
const FormLabel_1 = require("../../../../material-ui-theme/components/styled/FormLabel");
const companyQuery_1 = require("../../../../queries/companyQuery");
const currenciesQuery_1 = require("../../../../queries/currenciesQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const approvalLimitValidator_1 = require("../../../../validators/approvalLimitValidator");
const zustandStore_1 = require("../../../../zustandStore");
const tagLabelList_1 = __importDefault(require("../../../molecules/label/tagLabelList"));
const requestLimitValidationText = (teamRequestLimit, companyRequestLimit) => {
    const teamLimit = lodash_1.default.isObject(teamRequestLimit) ? null : teamRequestLimit;
    const companyLimit = lodash_1.default.isObject(companyRequestLimit) ? null : companyRequestLimit;
    const initialInfo = [`${strings_1.userDetailsStrings.NO_REQUEST_LIMIT_TEAM_TEXT}`];
    if (teamLimit) {
        initialInfo.push(`${strings_1.userDetailsStrings.REQUEST_LIMIT_VALIDATION_TEXT(teamRequestLimit)}`);
    }
    else if (companyLimit) {
        initialInfo.push(`${strings_1.userDetailsStrings.REQUEST_LIMIT_VALIDATION_TEXT(companyRequestLimit)}`);
    }
    return initialInfo;
};
const RequestLimitInput = ({ value = '', onChange = () => ({}) }) => {
    const { data: companyRequestLimit } = (0, companyQuery_1.useGetRequestLimitQuery)();
    const { data: teamId } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const { setIsUserDetailSaveBtnDisabled, setRequestLimitError } = (0, zustandStore_1.useZustand)();
    const { data: teamRequestLimit } = (0, teamQuery_1.useGetTeamRequestLimitQuery)(teamId?.[0] || '');
    const textList = requestLimitValidationText(teamRequestLimit, companyRequestLimit);
    const { data: currencies } = (0, react_query_1.useQuery)((0, currenciesQuery_1.getCurrenciesQuery)(teamId?.[0] || ''));
    const error = (0, approvalLimitValidator_1.validateApprovalLimit)(value, teamRequestLimit || companyRequestLimit);
    const hsbcString = teamRequestLimit
        ? strings_1.teamInfoStrings.EXCEEDS_TEAM_LIMIT_TEXT
        : strings_1.teamInfoStrings.EXCEEDS_COMPANY_LIMIT_TEXT;
    const errorMessage = {
        [approvalLimitValidator_1.validator.errors.INVALID_FORMAT]: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP
            ? strings_1.teamInfoStrings.INVALID_NUMBER_TEXT
            : strings_1.teamInfoStrings.HSBC_INVALID_NUMBER_TEXT,
        [approvalLimitValidator_1.validator.errors.EXCEEDED_AMOUNT]: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP
            ? strings_1.teamInfoStrings.EXCEEDS_AMEX_APPROVAL_LIMIT_TEXT
            : hsbcString,
    };
    (0, react_1.useEffect)(() => {
        if (lodash_1.default.isEmpty(errorMessage[error])) {
            setIsUserDetailSaveBtnDisabled(false);
        }
        else {
            setIsUserDetailSaveBtnDisabled(true);
        }
        setRequestLimitError(value ? errorMessage[error] : '');
    }, [error, value, errorMessage]);
    return ((0, jsx_runtime_1.jsxs)("fieldset", { style: { width: '100%' }, children: [(0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { pt: 1 }, children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { children: strings_1.companySettingsTeamsStrings.APPROVAL_LIMIT }), (0, jsx_runtime_1.jsx)(material_1.OutlinedInput, { endAdornment: (currencies && currencies.length > 0 && currencies[0]) || 'N/A', name: strings_1.companySettingsTeamsStrings.APPROVAL_LIMIT, type: 'text', value: value, onChange: onChange })] }), !lodash_1.default.isEmpty(errorMessage[error]) && ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "error", variant: 'outlined', icon: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(status_and_notifications_1.StatusErrorOnLight, { style: { width: '24px', height: '24px' } })) : ((0, jsx_runtime_1.jsx)(Warning_1.default, {})), children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", sx: {
                        color: 'error',
                    }, children: errorMessage[error] }) })), textList.length > 0 && (0, jsx_runtime_1.jsx)(tagLabelList_1.default, { textList: textList, type: uiConstants_1.UI_TAG_PRIMARY })] }));
};
exports.default = RequestLimitInput;
